<script setup lang="ts">
import {ref} from "vue";
import {Plus, X} from "@lucide/vue";

const {modelValue} = defineProps<{
    modelValue: string[];
    placeholder: string;
}>();

const emits = defineEmits<{ (event: 'update:modelValue', chips: string[]): void }>();

const draft = ref<string>('');

/**
 * Append the drafted chip, ignoring empties and duplicates.
 */
const add = () => {
    const value = draft.value.trim();

    if (!value || modelValue.some(chip => chip.toLowerCase() === value.toLowerCase())) {
        draft.value = '';

        return;
    }

    emits('update:modelValue', [...modelValue, value]);
    draft.value = '';
};

const remove = (chip: string) => {
    emits('update:modelValue', modelValue.filter(item => item !== chip));
};
</script>

<template>
  <div class="flex flex-wrap items-center gap-1.5">
    <span
      v-for="chip in modelValue"
      :key="chip"
      class="inline-flex items-center gap-1.5 rounded-lg bg-primary/10 px-2.5 py-1 text-xs font-medium text-primary"
    >
      {{ chip }}
      <button class="opacity-60 hover:opacity-100 transition-opacity" @click="remove(chip)">
        <X class="size-3.5" />
      </button>
    </span>
    <span class="inline-flex items-center gap-1 rounded-lg border border-dashed border-gray-300 py-0.5 pl-2 pr-1">
      <input
        v-model="draft"
        :placeholder="placeholder"
        class="w-28 border-none bg-transparent text-xs outline-none"
        @keydown.enter.prevent="add"
      >
      <button
        class="flex size-5 items-center justify-center rounded-md bg-primary text-white"
        @click="add"
      >
        <Plus class="size-3.5" />
      </button>
    </span>
  </div>
</template>
